<template>
    <div class="app-inner fixed fixed-head-2">

        <!--/-->
        <div class="app-head">
            <common-header></common-header>
            <common-nav></common-nav>
        </div>

        <!--/-->
        <div class="app-body">
            <my-bscroll>
                <div class="app-body-container" style="padding-bottom: 30px">

                    <!--面包屑-->
                    <el-breadcrumb separator="/" class="mybreadcrumb" style="padding-left: 20px;padding-right: 20px">
                      <el-breadcrumb-item :to="{ path: '/monitor/index' }">监测台</el-breadcrumb-item>
                      <el-breadcrumb-item>布置工作任务</el-breadcrumb-item>
                    </el-breadcrumb>

                    <!--管订单-->
                    <el-row>
                        <el-col :span="24">
                            <el-card shadow="hover" class="mycard-a" style="min-height: 200px" v-loading="tasks_loading">
                                <div class="mycard-title">
                                    管订单
                                    <el-popover placement="right" width="360" trigger="hover">
                                        <div>
                                            选择管理订单的任务后，机器人会自动按照提前设置好的指令自动工作，无需人工操作。
                                            首次使用请前往<router-link to="/config/strategy">规则策略</router-link>中完成指令设置。
                                        </div>
                                        <i class="iconfont iconft-question mycard-title-icon" slot="reference"></i>
                                    </el-popover>
                                </div>
                                <div class="dotask-list">

                                    <div class="dotask-item"
                                         v-for="item in tasks"
                                         v-if="item.classify==1"
                                         :class="item.isStart==1?'':''"
                                        >
                                      <!--@click="toggleSelected(item)"-->


                                      <!--<el-tag size="small" class="task-tag" v-if="item.isStart==1">已开启</el-tag>-->
                                        <div class="dt-icon"><img src="@/assets/task-icon.png"></div>
                                        <div class="dt-title">
                                          <div class="dt-title-switch">
                                            <span>{{item.name}}</span>
                                            <el-tooltip :content="item.isSelected?'点击禁用':'点击启用'" placement="top">
                                              <el-switch
                                                v-model="item.isSelected"
                                                active-color="#13ce66"
                                                inactive-color="#ff4949"
                                                @change="toggles(item)">
                                              </el-switch>
                                            </el-tooltip>
                                          </div>
                                        </div>
                                        <div class="dt-body">{{item.description}}</div>
                                    </div>

                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <!--管库存-->
                    <el-row class="mg-t-10">
                        <el-col :span="24">
                            <el-card shadow="hover" class="mycard-a" style="min-height: 200px" v-loading="tasks_loading">
                                <div class="mycard-title">
                                    管库存
                                    <el-popover placement="right" width="360" trigger="hover">
                                        <div>
                                            选择管理库存的任务后，机器人会自动完成以下选择的工作任务。请前往规则策略中提前完成指令设置。
                                        </div>
                                        <i class="iconfont iconft-question mycard-title-icon" slot="reference"></i>
                                    </el-popover>
                                </div>
                                <div class="dotask-list">

                                    <div class="dotask-item"
                                         v-for="item in tasks"
                                         v-if="item.classify==2"
                                         :class="item.isStart==1?'':''"
                                        >
                                      <!--@click="toggleSelected(item)"-->
                                        <!--<el-tag size="small" class="task-tag" v-if="item.isStart==1">已开启</el-tag>-->
                                        <div class="dt-icon"><img src="@/assets/task-icon.png"></div>
                                        <div class="dt-title">
                                          <div class="dt-title-switch">
                                            <span>{{item.name}}</span>
                                            <el-switch
                                              v-model="item.isSelected"
                                              active-color="#13ce66"
                                              inactive-color="#ff4949"
                                              @change="toggles(item)">

                                            </el-switch>
                                          </div>
                                        </div>
                                        <div class="dt-body">{{item.description}}</div>
                                    </div>

                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <!--管报表-->
                    <el-row class="mg-t-10">
                        <el-col :span="24">
                            <el-card shadow="hover" class="mycard-a" style="min-height: 200px" v-loading="tasks_loading">
                                <div class="mycard-title">
                                    管报表
                                    <el-popover placement="right" width="360" trigger="hover">
                                        <div>
                                            选择报告任务后，机器人会自动按时完成以下选择的工作任务并在报表提醒窗口提醒
                                        </div>
                                        <i class="iconfont iconft-question mycard-title-icon" slot="reference"></i>
                                    </el-popover>
                                </div>
                                <div class="dotask-list">

                                    <div class="dotask-item"
                                         v-for="item in tasks"
                                         v-if="item.classify==3"
                                        >
                                      <!--:class="item.isStart==1?'selected':''"-->
                                        <!--<el-tag size="small" class="task-tag" v-if="item.isStart==1">已开启</el-tag>-->
                                        <div class="dt-icon"><img src="@/assets/task-icon.png"></div>
                                        <div class="dt-title">
                                          <div class="dt-title-switch">
                                            <span>{{item.name}}</span>
                                            <el-switch
                                              v-model="item.isSelected"
                                              active-color="#13ce66"
                                              inactive-color="#ff4949"
                                              @change="toggles(item)">

                                            </el-switch>
                                          </div>
                                        </div>
                                        <div class="dt-body">{{item.description}}</div>
                                    </div>

                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                </div>

                <div class="task-op-bar">
                    <div class="page-container">
                        <el-row>
                            <el-col :span="24">
                                <el-card shadow="hover" class="mycard-a">
                                    <el-button class="mybtn-sm mybtn-gray" @click="selectAlls" plain>全部启用</el-button>
                                    <el-button class="mybtn-sm mybtn-gray" @click="setWorkTime" plain>设置工作时间</el-button>
                                    <span style="margin-left: 20px">工作时间：{{time}}</span>
                                    <!--all-->
                                    <!--<el-tooltip  effect="dark" content="开始所有工作任务" placement="top">-->
                                        <!--<el-button :disabled="tasks_isStart==1" class="mybtn-sm mybtn-blue2" @click="doWork(1)" plain>开始工作</el-button>-->
                                    <!--</el-tooltip>-->
                                    <!--<el-tooltip effect="dark" content="结束所有工作任务" placement="top">-->
                                        <!--<el-button :disabled="tasks_isStart==0" class="mybtn-sm mybtn-blue2" @click="doWork(0)" plain>结束工作</el-button>-->
                                    <!--</el-tooltip>-->
                                    <!--选中-->
                                    <!--<el-tooltip effect="dark" content="开启当前选中的任务" placement="top">-->
                                        <!--<el-button class="mybtn-sm mybtn-blue" @click="doSelWork(1)" plain>保存</el-button>-->
                                    <!--</el-tooltip>-->
                                    <!--<el-tooltip v-if="hasSelect()" effect="dark" content="结束当前选中的任务" placement="top">-->
                                        <!--<el-button  class="mybtn-sm mybtn-blue" @click="doSelWork(0)" plain>结束选中任务</el-button>-->
                                    <!--</el-tooltip>-->
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </my-bscroll>
        </div>

        <!--设置工作时间-->
        <el-dialog title="设置工作时间" :visible.sync="timeSetDialogVisible" class="mydialog" :append-to-body="true" width="380px">
            <el-form :label-position="'left'" label-width="105px" class="myform">
                <el-form-item label="开始工作时间">
                    <el-time-picker
                            v-model="begin_time"
                            placeholder="请选择">
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="结束工作时间">
                    <el-time-picker
                            v-model="end_time"
                            placeholder="请选择">
                    </el-time-picker>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="mybtn-blue2" style="width: 170px" @click="saveWorkTime()">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {formatDate} from '@/common/filters'
export default {
    data: function () {
        return {
            tasks:[],
            tasks_loading:false,
            tasks_isStart:0,
            time:'',
            timeSetDialogVisible:false,
            begin_time:'',
            end_time:'',
            hasSelect:function(){
                let self = this
                let bol = false;
                self.tasks.forEach(function (item, idx) {
                    if (item.isSelected) {
                         bol = true;
                    }
                });
                return bol;
            }
        }
    },
    methods: {
        loadTasks: function (cb) {
            let self = this;
            self.tasks_loading = true
            self.xFetch.post(self.xApi('/robot/task/getTask'), {}).then(function (res) {
                self.tasks_loading = false
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.tasks = []
                    self.tasks_isStart = 0
                }
                else{
                    if(res.data.data.details&&res.data.data.details.length){
                      for(let i of res.data.data.details){
                        i.isSelected = i.isStart === 1;
                      }
                    }
                    self.tasks = res.data.data.details&&res.data.data.details.length ? res.data.data.details : []
                    self.tasks_isStart = res.data.data.isStart == 1 ? 1 : 0;
                    self.time = res.data.data.beginTime == '' ? '' : res.data.data.beginTime + ' - ' + res.data.data.endTime;
                }
                self.$nextTick(function () {
                    cb && cb()
                })
            });
        },
        toggleSelected: function (selItem) {
            let self = this
            self.tasks.forEach(function (item, idx) {
                if (item.type == selItem.type) {
                    item.isSelected = !item.isSelected
                    self.$set(self.tasks, idx, item)
                }
            });
        },
        toggles(item){
          this.keep(item.isStart == 1? 0 : 1,[item.type]);
        },
        selectAlls(){
          let self = this;
          let types = [];
          self.tasks.forEach(function (item, idx) {
            types.push(item.type);
          });
          if (!types.length) {
            self.xEui.msg_error('至少选择一个任务');
            return;
          }
          self.keep(1,types);
        },
        keep(isStart,types){
          let self = this;
          self.xEui.myloading(isStart == 1 ? '开启中...' : '关闭中...');
          self.xFetch.post(self.xApi('/robot/task/choiceDetails'), {
            'types[]':types,
            'isStart':isStart
          },{xPostType:'form'}).then(function (res) {
            self.xEui.loading_close()
            if (res.data.code != '00') {
              self.xEui.msg_error(res.data.text)
              return
            }
            self.xEui.msg_success('操作成功')
            self.loadTasks();
          });
//          self.xEui.alert('', '确定要' + (isStart == 1 ? '开启选中任务' : '结束选中任务') + '吗？', function () {
//
//          })
        },
        setSingleSelected: function (type, bol) {
            let self = this
            self.tasks.forEach(function (item, idx) {
                item.isSelected = item.type == type ? bol : false;
                self.$set(self.tasks, idx, item)
            });
        },
        hasSelectAll: function () {
            let result = true
            let self = this
            self.tasks.forEach(function (item, idx) {
                if (!item.isSelected) {
                    result = false;
                }
            });
            return result;
        },
        // 底部操作
        selectAll: function () {
            let isSelect = this.hasSelectAll() ? false : true
            let self = this
            let list = self.tasks.concat()
            list.forEach(function (item, idx) {
                item.isSelected = isSelect
            });
            self.tasks = list;
        },
        setWorkTime: function () {
            this.timeSetDialogVisible = true
        },
        saveWorkTime: function(){
            let self = this;

            if(!self.begin_time){
                self.xEui.msg_error('请选择开始工作时间')
                return;
            }

            if(!self.end_time){
                self.xEui.msg_error('请选择结束工作时间')
                return;
            }

            self.xEui.myloading('操作中...');
            self.xFetch.post(self.xApi('/robot/task/setTime'), {
                begin: formatDate(self.begin_time, 'hh:mm:ss'),
                end: formatDate(self.end_time, 'hh:mm:ss')
            },{xPostType:'form'} ).then(function (res) {
                self.xEui.loading_close()

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                self.timeSetDialogVisible = false;
                self.xEui.msg_success('设置成功')
                self.loadTasks();
            });
        },
        doWork: function(isStart){
            let self = this;
            self.xEui.alert('', '确定要' + (isStart == 1 ? '开始工作' : '结束工作') + '吗？', function () {
                self.xEui.myloading(isStart == 1 ? '开启中...' : '关闭中...');
                self.xFetch.post(self.xApi('/robot/task/setStart'), {
                    isStart: isStart
                },{xPostType:'form'}).then(function (res) {

//                  console.log(res)
                    self.xEui.loading_close()
                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    self.xEui.msg_success('操作成功')
                    self.loadTasks();
                });
            })
        },
        doSelWork: function(isStart){
            let self = this;

            let types = []
            self.tasks.forEach(function (item, idx) {
                if (item.isSelected) {
                    types.push(item.type);
                }
            });
            if (!types.length) {
                self.xEui.msg_error('至少选择一个任务')
                return;
            }
//            console.log(self.tasks)
//            return;
            self.xEui.alert('', '确定要' + (isStart == 1 ? '开启选中任务' : '结束选中任务') + '吗？', function () {
                self.xEui.myloading(isStart == 1 ? '开启中...' : '关闭中...');
                self.xFetch.post(self.xApi('/robot/task/choiceDetails'), {
                    'types[]':types,
                    'isStart':isStart
                },{xPostType:'form'}).then(function (res) {
                    self.xEui.loading_close()
                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    self.xEui.msg_success('操作成功')
                    self.loadTasks();
                });
            })
        }
    },
    created: function(){
      let self = this;

      if (!self.tasks.length) {
        // 加载任务列表
        self.loadTasks(function () {
          // 默认选中的任务
          if (self.$route.query.type) {
            self.setSingleSelected(self.$route.query.type, true)
          }
        })
      }
      else{
        // 默认选中的任务
        if (self.$route.query.type) {
          self.setSingleSelected(self.$route.query.type, true)
        }
      }
    },
    // keep-alive事件
  activated:function(){
        let self = this;

        if (!self.tasks.length) {
            // 加载任务列表
            self.loadTasks(function () {
                // 默认选中的任务
                if (self.$route.query.type) {
                    self.setSingleSelected(self.$route.query.type, true)
                }
            })
        }
        else{
            // 默认选中的任务
            if (self.$route.query.type) {
                self.setSingleSelected(self.$route.query.type, true)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mycard-title{color: #606266;font-size: 16px}
    .mycard-title .mycard-title-icon{ font-size: 18px;position: relative;top: -5px }
    /*dotask-list*/
    .dotask-list{ }
    .dotask-list:after{ content: '';display: table;clear: both }
    .dotask-list .dotask-item{
        float: left;
        width:286px;
        height: 126px;
        margin: 16px 16px 0px 0px;
        border: 1px solid #E6EAEE;
        position: relative;
        cursor: pointer;
    }
    .dotask-list .dotask-item.selected{
        border-color:#E39A00;
    }
    .dotask-list .dotask-item.selected:before{
        content: '';
        display: table;
        width: 22px;
        height: 22px;
        position: absolute;
        top: 0;
        right: 0;
        background: url("../../assets/task_sel_triangle.png") 0 0 no-repeat;
    }
    .dotask-list .dotask-item .task-tag{position: absolute;left: 5px;top: 5px;}
    .dotask-list .dt-icon{ float: left }
    .dotask-list .dt-icon img{ width: 46px;height: 46px;margin-left: 26px;margin-top: 40px }
    .dotask-list .dt-title{
        padding: 20px 10px 10px 100px;
        font-size: 14px;
        color: #707090;
        font-weight: bolder;
    }
    .dt-title-switch{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .dotask-list .dt-body{
        padding: 0px 10px 10px 100px;
        font-size: 12px;
        color: #707090;
    }
    /*task-op-bar*/
    .task-op-bar{ background: #fff;position: fixed;left: 0;bottom: 0;width: 100%; }
</style>
<style>
    /*task-op-bar*/
    .task-op-bar .el-card__body{ padding: 12px 0px;}
</style>



// WEBPACK FOOTER //
// src/views/monitor/task.vue